<script setup lang="ts">
import { AppBreadcrumbs } from '~/components';
definePageMeta({
  // auth: {
  //   unauthenticatedOnly: true,
  //   navigateAuthenticatedTo: '/',
  // },
});
useHead({
  title: 'Terms and Conditions',
});
const { data } = await useFetchData('/pages/terms_of_service', { method: 'get' });
</script>

<template>
  <v-container class="pa-0 mt-5 mb-10">
    <AppBreadcrumbs />

    <div class="pt-6">
      <div v-html="data"></div>
    </div>
  </v-container>
</template>
